import {TipoAttributo} from '../../../common/model/tipoattributo.enum';
import {Attributo} from '../../../common/model/attributo.model';

export class TipoEntitaOrganizzativaAttributo extends Attributo {

  constructor(public id: number,
              public nome: string,
              public tipo: TipoAttributo) {
    super(id, nome, tipo);
  }


}
